function setAccordionEventListeners( ) 
{
    window.addEventListener( 'resize', function( )
    {
        var currentWidth = window.innerWidth;
        var blogs        = document.querySelectorAll( '.js-toc-blogs' );
        var arrows       = document.querySelectorAll( '.js-toc-arrow' );

        if ( currentWidth > 1200 )
        {
            
            blogs.forEach( function( blog )
            {
                blog.style.maxHeight = null;
            } );
        }
        else
        {

            blogs.forEach( function( blog, index )
            {
                if ( blog.style.maxHeight )
                {
                    blog.style.maxHeight = blog.scrollHeight + "px";
                    arrows[ index ].classList.add( "active" );
                }
                else
                {
                    blog.style.maxHeight = null;
                    arrows[ index ].classList.remove( "active" );
                }
            } );
        }
    } );
}

/**
 * 
 * @param { HTMLDivElement } accordion 
 */
function initAccordion( accordion )
{
    var headers = document.querySelectorAll( '.js-toc-header' );
    if ( headers.length && headers.length > 0 )
    {
        headers.forEach( function( header )
        {
            if ( !header.dataset.listenerAdded )
            {
                header.addEventListener( "click", function( ) 
                {
                    var blogs = this.nextElementSibling;
                    var arrow = this.querySelector( '.js-toc-arrow' );
                    if ( blogs.style.maxHeight )
                    {
                        blogs.style.maxHeight = null;
                        arrow.classList.toggle( 'active' );
                    }
                    else
                    {
                        blogs.style.maxHeight = blogs.scrollHeight + "px";
                        arrow.classList.toggle( 'active' );
                    }   
                } );
                header.dataset.listenerAdded = true;
            }
        } );
    }

    setAccordionEventListeners( );
}

function initBlogTOC( )
{
    const tocs = document.querySelectorAll( ".js-toc-container" );
    tocs.forEach( function( toc )
    {
        initAccordion( toc );
    } );
}

window.addEventListener( "DOMContentLoaded", initBlogTOC );

if ( Shopify.designMode )
{
    document.addEventListener( "shopify:section:load", function( event )
    {
        const section = event.target;
        const toc     = section.querySelector( ".js-toc-container" );

        if ( toc )
        {
            initAccordion( toc );
        }
    } );
}